/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { storeWhatsAppTemplateDataCategorySchema } from './StoreWhatsAppTemplateDataCategorySchema'

export const storeWhatsAppTemplateDataSchema = z.object({
	name: z.string(),
	language: z.string(),
	category: storeWhatsAppTemplateDataCategorySchema,
	bodyText: z.string(),
	exampleParameters: z.array(z.string()).nullable().optional().default([]),
})

export type StoreWhatsAppTemplateDataSchema = z.infer<typeof storeWhatsAppTemplateDataSchema>
